import { component } from 'picoapp';
import Swiper, { Navigation, SwiperOptions } from 'swiper';

export default component((node: HTMLElement) => {
  const slider: HTMLElement = node.querySelector('[data-slider]');
  const sliderMobile: HTMLElement = node.querySelector('[data-slider-mobile]');

  const config = JSON.parse(node.querySelector('[data-config]').textContent);

  const prev: HTMLButtonElement = node.querySelector('[data-prev]');
  const next: HTMLButtonElement = node.querySelector('[data-next]');
  const current: NodeListOf<HTMLElement> = document.querySelectorAll('[data-media-current]');

  let sliderConfig: SwiperOptions = {
    init: false,
    modules: [Navigation],
    navigation: {
      prevEl: prev,
      nextEl: next,
    },
    loop: true,
    slidesPerView: 1,
    spaceBetween: 15,
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 0,
      },
    },
    on: {
      slideChange: ({ realIndex }) => {
        current.forEach((val) => {
          val.textContent = `${realIndex + 1}`;
        });
      },
    },
  };

  if (config.has3DModel) {
    sliderConfig = {
      ...sliderConfig,
      ...{
        allowTouchMove: false,
        breakpoints: {
          992: {
            allowTouchMove: true,
            slidesPerView: 2,
            spaceBetween: 0,
          },
        },
      },
    };
  }

  const media = window.matchMedia('(min-width: 992px)');

  const init = () => {
    // eslint-disable no-new
    const desktopSlider = new Swiper(slider, sliderConfig);
    const mobileSlider = new Swiper(sliderMobile, sliderConfig);

    if (media.matches) {
      desktopSlider.init();
    } else {
      mobileSlider.init();
    }
  };

  init();
  media.addEventListener('change', init);
});
